import { render, staticRenderFns } from "./ProductListingLoading.vue?vue&type=template&id=e494f94c"
import script from "./ProductListingLoading.vue?vue&type=script&lang=ts"
export * from "./ProductListingLoading.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports